import { render, staticRenderFns } from "./DataManagementModal.vue?vue&type=template&id=9a8e1c9c&scoped=true"
import script from "./DataManagementModal.vue?vue&type=script&lang=js"
export * from "./DataManagementModal.vue?vue&type=script&lang=js"
import style0 from "./DataManagementModal.vue?vue&type=style&index=0&id=9a8e1c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e1c9c",
  null
  
)

export default component.exports